<template>
  <div>
    <el-dialog
      title="批量导入"
      :visible.sync="dialogVisible"
      width="862px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :show-close="true"
    >
      <div class="title-box">
        <div class="title-text">批量导入</div>
        <i class="el-icon-close" @click="close"></i>
      </div>
      <div class="step_box">
        <div class="step">
          <div class="step1"></div>
          <div class="step-intro">下载并解压模板，按照规范进行填写</div>
        </div>
        <div class="step ">
          <div class="step2"></div>
          <div class="step-intro">将填写完成的模板和上协议文件组成压缩包</div>

          <!-- <div class="content">
            <div class="label">第二步</div>
            <div class="tip">
              将填写完成的模板和待上传的协议文件、附件文件组成压缩包注意模板中的文件名称跟协议一一对应
            </div>
          </div> -->
        </div>
        <div class="step ">
          <div class="step3"></div>
          <div class="step-intro">上传文件压缩包，等待系统解析</div>
          <!-- <div class="content">
            <div class="label">第三步</div>
            <div class="tip">上传文件压缩包，等待系统解析</div>
          </div> -->
        </div>
      </div>
      <div class="upload_box">
        <div class="upload_box_left">
          <div style="display: flex" @click="onUpload">
            <div class="label">下载模板文件</div>
            <div class="btn point"><i class="el-icon-download"></i> 下载</div>
          </div>
          <div class="fileName">{{ "赋强公证批量上传信息模板.zip" }}</div>
        </div>
        <div class="line"></div>
        <div class="upload_box_right">
          <div style="display: flex">
            <div class="label">上传文件压缩包</div>
            <UploadOss
              v-loading="loadingUpload"
              class="cover"
              :curCount="contractList.length"
              @uploadSuccess="upload"
              @loading="loadingUpload = true"
              @loadingEnd="loadingUpload = false"
              accept=".zip"
            >
              <div class="btn" slot="uploadContent">
                <i class="el-icon-upload2"></i> 上传
              </div>
            </UploadOss>
          </div>
          <div class="file-box" v-if="contractList && contractList.length">
            <div class="file-name">
              <span>{{ contractList[0].fileName }}</span>
            </div>
            <div class="delete" @click="onDelete">
              <i class="el-icon-delete"></i>
              <span>删除</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" class="reset-button" @click="close"
          >放弃导入</el-button
        >
        <el-button
          type="danger"
          :disabled="!contractList.length"
          @click="onExport"
          class="reset-button"
          >确定导入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Upload from "@common/upload.vue";
import UploadOss from "@common/uploadOss.vue";
import BaseApi from "@lib/baseApi.js";

export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Upload,
    UploadOss,
  },

  data() {
    return {
      contractList: [],
      importDisabled: true,

      loadingUpload: false,
    };
  },

  created() {},

  methods: {
    upload(item) {
      console.log(item, "item");
      this.contractList = [{ ...item.datas, fileName: item.file_name }];
    },

    close() {
      this.$emit("close");
    },

    onDelete() {
      this.contractList = [];
    },

    // 导入
    onExport() {
      this.$store.commit("showLoading", true);
      if (!this.contractList.length) {
        this.$message.error("请上传文件压缩包");
        return;
      }
      const fileInfo = this.contractList[0];
      BaseApi.createRpcToken("/import/batchAdd", {
        fileName: fileInfo.fileName,
        filePath: fileInfo.filePath,
      }).then(
        (data) => {
          this.$store.commit("showLoading", false);
          if (data.code == 200) {
            this.$emit("onExport", {
              ...data.datas,
              fileInfo,
            });
            this.$emit("close");
          } else {
            this.$message.error(data.message);
          }
        },
        (err) => {
          this.$store.commit("showLoading", false);
          this.$message.error(data.message);
        }
      );
    },

    // 下载合同模板
    onUpload() {
      BaseApi.createRpcToken(
        "/export/downloadTemplate",
        {},
        "GET",
        false,
        false,
        true,
        "blob"
      ).then(
        (data) => {
          console.log(data, "data");
          //   url, data, method, encode = false,
          // cache = false, isCommonHandler = true, responseType, isNotFormat, isVery = true
          if (data.status == 200) {
            // this.downloadManager.downloadData(this.content, this.filename, '');
            const blob = new Blob([data.data], {
              type: "application/zip;chartset=UTF-8",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "赋强公证批量上传信息模板.zip";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
          }
        },
        (err) => {}
      );
    },
  },
};
</script>

<style scoped lang="scss">
.title-box {
  position: relative;
  height: 48px;
  .title-text {
    height: 48px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #646464;
    line-height: 48px;
  }
  .el-icon-close {
    cursor: pointer;
    font-size: 24px;
    color: #BDBDBD;
    font-weight: bold;
    position: absolute;
    top: 8px;
    right: 0;
  }
}
.step_box {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  .step {
    width: 261px;
    height: 261px;
    text-align: center;
    .content {
      color: #ffffff;

      .label {
        font-size: 24px;
        line-height: 48px;
        margin-bottom: 8px;
        margin-top: 46px;
      }
      .tip {
        font-size: 18px;
        line-height: 32px;
        margin: 0 50px;
      }
    }

    .step-intro {
      font-size: 12px;
      color: #AD3C48;
    }
  }
  .step1 {
    width: 203px;
    height: 203px;
    margin: 20px auto 10px;
    background: url("../../../../assets/images/index/batchStep1.png") no-repeat;
    background-size: 100% 100%;
  }
  .step2 {
    width: 203px;
    height: 203px;
    margin: 20px auto 10px;
    background: url("../../../../assets/images/index/batchStep2.png") no-repeat;
    background-size: 100% 100%;
  }
  .step3 {
    width: 203px;
    height: 203px;
    margin: 20px auto 10px;
    background: url("../../../../assets/images/index/batchStep3.png") no-repeat;
    background-size: 100% 100%;
  }
}
.upload_box {
  position: relative;
  color: #646464;
  height: 120px;
  display: flex;
  .line {
    position: absolute;
    width: 2px;
    left: 50%;
    height: 120px;
    background-color: #bdbdbd;
  }
  .upload_box_left,
  .upload_box_right {
    margin-top: 8px;
    flex: 1;
    .label {
      font-size: 18px;
      margin-right: 24px;
      line-height: 32px;
    }
    .btn {
      padding: 3px 24px;
      border: 1px solid #db1c1b;
      height: 24px;
      display: flex;
      align-items: center;
      color: #db1c1b;
      i {
        margin-right: 5px;
      }
    }
  }
  .upload_box_left {
    padding-left: 70px;
  }
  .fileName {
    margin-top: 24px;
    color: #646464;
    font-size: 14px;
    line-height: 32px;
  }
  .right {
  }
}
::v-deep {
  .el-dialog__body {
    padding: 20px 40px;
  }
  .el-button--danger {
    color: #fff;
    background-color: #db1c1b;
    border-color: #db1c1b;
    font-size: 12px;
  }
  .el-button--danger.is-disabled,
  .el-button--danger.is-disabled:active,
  .el-button--danger.is-disabled:focus,
  .el-button--danger.is-disabled:hover {
    color: #fff;
    background-color: #fab6b6;
    border-color: #fab6b6;
  }

  .el-button--mini {
    padding: 7px 15px;
  }
}
.point {
  cursor: pointer;
}

.file-box {
  width: 285px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e9e9e9;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 0 24px;
  margin-top: 26px;
  .file-name {
    font-weight: 500;
    color: #bdbdbd;
    line-height: 32px;
    flex: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .delete {
    font-weight: 500;
    color: #bdbdbd;
    line-height: 32px;
    cursor: pointer;

    .el-icon-delete {
      margin-right: 4px;
    }
  }
}

.reset-button {
  width: 132px;
  height: 35px;
  border-radius: 2px;
  padding: 7px 15px;
}
</style>
